module.exports = __webpack_public_path__ + "static/media/reader.0a94dd0a.mov";